import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const CompanyList = Loadable(lazy(() => import('./CompanyList')));
const AddCompany = Loadable(lazy(() => import('./AddCompany')));

const CompanyRoutes = [
	{
		path: '/Company/list',
		element: <CompanyList />,
		auth: authRoles.admin,
	},
	{
		path: '/Company/manage',
		element: <AddCompany />,
		auth: authRoles.admin,
	},
];

export default CompanyRoutes;
